import Typography from "../typography/typography";
import { Box } from "@mui/material";
import "./grid-fallback.scss";
import logo from '../../assets/images';

interface GridFallbackProps {
  heading?: string;
  subHeading?: string;
  icon?: React.ReactNode;
  children?: React.ReactNode;
}

const GridFallback = (props: GridFallbackProps) => {
  const { heading = '', subHeading = 'No data available', icon = <img src={logo.invoiceFallback} />, children, ...rest } = props;
  return (
    <Box className="fallback" {...rest}>
      {icon}
      <Typography
        type="h5"
        weight="medium"
        color="theme.secondary.1000"
        className="fallback--Text"
      >
        {heading}
      </Typography>
      <Typography
        type="s3"
        weight="medium"
        color="theme.secondary.800"
        className="fallback--Text"
      >
        {subHeading}
      </Typography>
      <div>{children}</div>
    </Box>
  );
};

export { GridFallback };
export default GridFallback;
